import { useIntl } from "react-intl";

import { MobileNavCard } from "../../mobile-nav/mobile-nav-card";
import { type Product, ProductItem, Treatment } from "../../product-subnav";
import { useAnalytics } from "../hooks/use-analytics";

import { BaseGrid } from "./base-grid";

type ProductsGridProps = {
    products: Product[];
    title: string;
    isMobile?: boolean;
    container: "ProductsRecommendationsContainer" | "NewProductsContainer";
};

export const ProductsGrid = ({
    products,
    title,
    isMobile,
    container
}: ProductsGridProps) => {
    const intl = useIntl();
    const { fireCardClicked } = useAnalytics({ isMobile });

    const handleCardClick = (product: Product) => {
        fireCardClicked(container, product);
    };

    const productItems = products.map((product: Product) => {
        return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div key={product.id} onClick={() => handleCardClick(product)}>
                {isMobile ? (
                    <MobileNavCard
                        {...product}
                        description={intl.formatMessage(product.description)}
                        isNew={product.treatment === Treatment.New}
                        productKey={"home"}
                    />
                ) : (
                    <ProductItem {...product} />
                )}
            </div>
        );
    });

    return (
        <BaseGrid products={productItems} title={title} isMobile={isMobile} />
    );
};
